import { DefaultTheme, css } from 'styled-components';
import { BREAKPOINTS } from './enum/EnumRepository';


type MQ = { [K in keyof typeof BREAKPOINTS]: (literals: TemplateStringsArray, ...args: any[]) => any };
const media = Object.keys(BREAKPOINTS).reduce((acc, label) => {
  // label is 'desktop' | 'tablet' | 'mobile'
  acc[label as keyof typeof BREAKPOINTS] = (
    literals: TemplateStringsArray,
    ...args: any[]
  ) => css`
    @media (max-width: ${BREAKPOINTS[label as keyof typeof BREAKPOINTS]}) {
      ${css(literals, ...args)}
    }
  `;
  return acc;
}, {} as MQ);

const theme: DefaultTheme = {
  breakpoints: BREAKPOINTS,
  media,
  colors: {
    color_Gray_01: '#1a1a1a',
    color_Gray_02: '#252525',
    color_Gray_03: '#4d4d4d',
    color_Gray_04: '#7d7d7d',
    color_Gray_05: '#b3b3b3',
    color_Gray_06: '#F0F0F0',
    color_Gray_07: '#F7F7F7',
    color_White: '#ffffff',
    color_Alpha_01: 'rgba(0, 0, 0, 0.6)',
    color_Alpha_02: 'rgba(0, 0, 0, 0.05)',
    color_Alpha_031: 'rgba(255, 255, 255, 0.05)',
    color_Alpha_032: 'rgba(255, 255, 255, 0.15)',
    color_Alpha_03: 'rgba(255, 255, 255, 0.3)',
    color_Alpha_04: 'rgba(255, 255, 255, 0.5)',
    color_Alpha_05: 'rgba(255, 255, 255, 0.6)',
    color_alert_green: "#4CAF50",
    color_alert_red: '#FA4545'
  },
  fontSize: {
    font_H03: 'clamp(1.1rem, 2.2vw, 1.8rem)',
    font_B00: 'clamp(0.95rem, 1.8vw, 1.4rem)',
    font_B01: 'clamp(0.95rem, 1.2vw, 1.25rem)',
    font_B02: 'clamp(0.85rem, 1vw, 1rem)',
    font_B03: 'clamp(0.75rem, 0.9vw, 0.875rem)',
    font_B04: 'clamp(0.7rem, 0.8vw, 0.75rem)',
    font_B05: 'clamp(0.65rem, 0.75vw, 0.65rem)',
    font_B06: 'clamp(0.6rem, 0.7vw, 0.6rem)',
  },
  fontWeight: {
    semi_bold: '600',
    medium: '500',
    regular: '400',
    decoration: 'underline'
  },
  typography: {
    H_03: css`
      font-size: ${props => props.theme.fontSize.font_H03};
      font-weight: ${props => props.theme.fontWeight.semi_bold};
      ${media.TABLET`line-height:1.4;`}
      ${media.MOBILE`line-height:1.35;`}
    `,
    Body_00_1: css`
      font-size: ${props => props.theme.fontSize.font_B00};
      font-weight: ${props => props.theme.fontWeight.semi_bold};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_01_1: css`
      font-size: ${props => props.theme.fontSize.font_B01};
      font-weight: ${props => props.theme.fontWeight.semi_bold};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_01_2: css`
      font-size: ${props => props.theme.fontSize.font_B01};
      font-weight: ${props => props.theme.fontWeight.medium};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_01_2U: css`
      font-size: ${props => props.theme.fontSize.font_B01};
      font-weight: ${props => props.theme.fontWeight.medium};
      font-decoration: ${props => props.theme.fontWeight.decoration};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_02_1: css`
      font-size: ${props => props.theme.fontSize.font_B02};
      font-weight: ${props => props.theme.fontWeight.medium};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_02_2: css`
      font-size: ${props => props.theme.fontSize.font_B02};
      font-weight: ${props => props.theme.fontWeight.regular};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_03_1: css`
      font-size: ${props => props.theme.fontSize.font_B03};
      font-weight: ${props => props.theme.fontWeight.medium};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_03_2: css`
      font-size: ${props => props.theme.fontSize.font_B03};
      font-weight: ${props => props.theme.fontWeight.regular};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Body_04: css`
      font-size: ${props => props.theme.fontSize.font_B04};
      font-weight: ${props => props.theme.fontWeight.regular};
      ${media.TABLET`line-height:1.5;`}
      ${media.MOBILE`line-height:1.45;`}
    `,
    Footer_01: css`
    font-size: ${props => props.theme.fontSize.font_B05};
    font-weight: ${props => props.theme.fontWeight.regular};
    ${media.TABLET`line-height:1.2;`}
    ${media.MOBILE`line-height:1.15;`}
  `,
    Footer_02: css`
    font-size: ${props => props.theme.fontSize.font_B06};
    font-weight: ${props => props.theme.fontWeight.regular};
    ${media.TABLET`line-height:1.2;`}
    ${media.MOBILE`line-height:1.15;`}
  `,
  }
};

export default theme;